module.exports = __webpack_public_path__ + "df4acc21f6df104e0531acae1b844e2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-thick.png
// module id = 1824
// module chunks = 0